import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { API_URL, TICKET_API_URL } from "utils/constants";
import { request } from "utils/request";
import { actions } from "app/containers/Features/components/CommonTagSelection/redux/slice";
import { actions as appActions } from "app/redux/slice";
import { handleApiError } from "utils/errorHandler";
import toastService from "utils/toast";
import { ITags } from "../types";
import { selectTagsForm } from "./selector";

export function* createTagsRequest(action: {
  payload: { callback: () => void };
}) {
  yield delay(500);
  try {
    const form: ITags = yield select(selectTagsForm);
    yield put(actions.setLoading(true));
    const requestURL = `${TICKET_API_URL}tags/create`;
    const options = {
      method: "POST",
      body: JSON.stringify(form),
    };

    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    toastService.success(data?.message);
    yield put(appActions.createTagLocally(data?.data));

    action.payload.callback();
  } catch (err: any) {
    yield put(actions.setLoading(false));
    handleApiError(err);
  }
}
export function* updateTagsRequest(action: {
  payload: { callback: () => void };
}) {
  yield delay(500);
  try {
    const form: ITags = yield select(selectTagsForm);
    yield put(actions.setLoading(true));

    const formData = {
      title: form.title,
      color: form.color,
    };
    const requestURL = `${TICKET_API_URL}tags/update/${form._id}`;
    const options = {
      method: "PUT",
      body: JSON.stringify(formData),
    };

    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    toastService.success(data?.message);
    yield put(appActions.updateTagsLocallyById({ id: form._id, changes: formData }));
    yield call(action.payload.callback);
  } catch (err: any) {
    yield put(actions.setLoading(false));
    handleApiError(err);
  }
}
export function* deleteTagRequest(action: {
  payload: { id: string; callback: () => void };
}) {
  yield delay(500);
  try {
    const form: ITags = yield select(selectTagsForm);
    yield put(actions.setButtonLoading(true));
    const requestURL = `${TICKET_API_URL}tags/delete/${form._id}`;
    const options = {
      method: "DELETE",
    };

    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    toastService.success(data?.message);
    yield put(appActions.removeTagsLocally(form._id));
    yield call(action.payload.callback);
  } catch (err: any) {
    yield put(actions.setButtonLoading(false));
    handleApiError(err);
  }
}

export default function* ticketTagsSaga() {
  yield takeLatest(actions.createTags, createTagsRequest);
  yield takeLatest(actions.updateTags, updateTagsRequest);
  yield takeLatest(actions.deleteTag, deleteTagRequest);
}
